/**
 * Design Token Colors — Single Source of Truth
 *
 * Used by:
 *   1. tailwind.config.js  →  require('./src/styles/colors')
 *   2. React components     →  import colors from '../styles/colors'
 *
 * Any color value that appears in JS (inline styles, FullCalendar props, etc.)
 * MUST reference this module instead of hardcoding hex strings.
 */

const colors = {
  mono: {
    '000': '#ffffff',
    50:  '#f8f9fc',
    100: '#f1f3f7',
    200: '#e2e5eb',
    300: '#ccd0d9',
    400: '#a3a9b5',
    500: '#6e7585',
    600: '#4e5564',
    700: '#2e3442',
    800: '#181c26',
    900: '#0c0f16',
  },
  orange: {
    50:  '#fff3e8',
    100: '#ffd9b8',
    200: '#ffb870',
    300: '#ff9e42',
    400: '#ff8533',
    500: '#ff6b00',
    600: '#e55d00',
    700: '#cc5200',
    800: '#993f00',
    900: '#662a00',
  },
  blue: {
    50:  '#ebf4ff',
    100: '#bdd8f9',
    300: '#5a9bd5',
    500: '#2b6cb0',
    700: '#1a4e80',
    800: '#143e69',
    900: '#0f2e52',
  },
  red: {
    50:  '#fef0f0',
    100: '#fccaca',
    300: '#f07070',
    500: '#e53e3e',
    700: '#a62b2b',
  },
  green: {
    50:  '#e8f8f3',
    100: '#b3e8d5',
    300: '#3dc9a0',
    500: '#0bab7c',
    700: '#077a58',
  },
  kakao:  { bg: '#FEE500', text: '#3C1E1E' },
  naver:  { bg: '#03C75A' },
  star: '#FFB800',

  /* ── Service accent colors (calendar, badges, etc.) ── */
  service: {
    airport:  '#ff6b00',   // = orange-500
    golf:     '#0bab7c',   // = green-500
    ski:      '#5a9bd5',   // = blue-300
    hospital: '#8b5cf6',
    pet:      '#f59e0b',
    business: '#6366f1',
    tour:     '#14b8a6',   // = teal-500 (ski 와 색 구분)
    shopping: '#ec4899',
  },
};

module.exports = colors;
